<!--
 * @Author: LiZhiWei
 * @Date: 2026-02-13 10:52:59
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-13 10:56:23
 * @Description: 
-->
<template>
  <button
    v-show="isVisible"
    class="scroll-to-top fixed right-32px bottom-15% z-200 wh-44px flex-center cursor-pointer select-none rounded-full bg-white/90 backdrop-blur-sm border border-white/80 text-slate-600 shadow-[0_10px_30px_rgba(15,23,42,0.16)] transition-all duration-300 hover:bg-white hover:text-blue-600 hover:border-blue-200 hover:shadow-[0_16px_40px_rgba(15,23,42,0.2)] hover:-translate-y-2 active:translate-y-0 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white lt-sm:right-24px lt-sm:bottom-24px lt-sm:wh-72px"
    aria-label="返回顶部"
    @click="scrollToTop"
  >
    <i class="i-ep-arrow-up font-s-18px lt-sm:font-s-28px" aria-hidden="true"></i>
  </button>
</template>

<script setup lang="ts">
  const props = withDefaults(defineProps<{ threshold?: number }>(), {
    threshold: 300,
  })

  const { y } = useWindowScroll()
  const isVisible = computed(() => y.value > props.threshold)

  const scrollToTop = () => {
    if (typeof window === 'undefined') return
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
</script>
